export default {
  Welcome: "Welcome",
  Home: "Home",
  Course: "Course",
  Lesson: "Lesson",
  About: "About"
};
